import React from 'react';
import PropType from 'prop-types';
import { useAppState } from '@brochure/globals';

import TrackedLink from '../TrackedLink';

const MobileNavigation = ({ signUpUrl }) => {
  const [isSignedIn, isAppSubmitted] = useAppState();

  return (
    <>
      <div className="menu-mobile-apply show-apply">
        {isSignedIn && !isAppSubmitted && (
          <TrackedLink
            href="/"
            className="pill-button medium header-apply green app-link logged-in incomplete-application"
          >
            Application
          </TrackedLink>
        )}
        {isSignedIn && isAppSubmitted && (
          <TrackedLink
            href="/"
            className="pill-button medium header-apply green app-link complete-application"
          >
            Dashboard
          </TrackedLink>
        )}
        {!isSignedIn && (
          <TrackedLink
            href="/"
            className="pill-button medium header-apply green app-link logged-out apply-button"
          >
            Apply Now
          </TrackedLink>
        )}
      </div>
      <div className="plp-sign-in-nav">
        {isSignedIn ? (
          <TrackedLink href="/Account/LogOff" className="app-link logged-in">
            Sign Out
          </TrackedLink>
        ) : (
          <TrackedLink href={signUpUrl} className="app-link logged-out">
            Sign In
          </TrackedLink>
        )}
      </div>
      <div className="clearfix mobile-clearfix" />
    </>
  );
};

MobileNavigation.propTypes = {
  signUpUrl: PropType.string.isRequired,
};

export default MobileNavigation;
